import Vue from 'vue'

// Better support than the padStart method
const padStart = function (originalStr, maxLength, complementStr) {
  originalStr += ''
  let auxStr = ''
  while (auxStr.length < maxLength - originalStr.length) auxStr += complementStr
  return auxStr.slice(0, maxLength - originalStr.length) + originalStr
}

export default el => new Vue({
  el,
  components: {
    'countdown-timer-signup': () => import('../countdown-timer/countdown-timer-signup.vue'),
  },
  data () {
    let days = 0
    let hours = 0
    let minutes = 0
    let seconds = 0
    let localTargetDate = new Date()
    if (el.dataset.serverTime && el.dataset.countdownDate) {
      const targetTime = new Date(el.dataset.countdownDate.replace(/ /g, 'T'))
      const currentTime = new Date((el.dataset.serverTime + ':' + new Date().getSeconds()).replace(/-/g, '/'))
      const MIN_S = 60
      const HOUR_S = 3600
      const DAY_S = HOUR_S * 24
      let COUNTDOWNTIME_S = Math.floor((targetTime.getTime() - currentTime.getTime()) / 1000)
      localTargetDate = new Date(localTargetDate.getTime() + (COUNTDOWNTIME_S * 1000))

      if (COUNTDOWNTIME_S > 0) {
        days = Math.floor(COUNTDOWNTIME_S / DAY_S)
        COUNTDOWNTIME_S %= DAY_S

        hours = Math.floor(COUNTDOWNTIME_S / HOUR_S)
        COUNTDOWNTIME_S %= HOUR_S

        minutes = Math.floor(COUNTDOWNTIME_S / MIN_S)
        seconds = COUNTDOWNTIME_S % MIN_S
      }
    }

    return {
      days,
      hours,
      minutes,
      seconds,
      localTargetDate
    }
  },
  computed: {
    getSeconds () {
      return padStart(this.seconds, 2, '0')
    },
    getMinutes () {
      return padStart(this.minutes, 2, '0')
    },
    getHours () {
      return padStart(this.hours, 2, '0')
    },
    getDays () {
      return padStart(this.days, 2, '0')
    }
  },
  methods: {
    tickSeconds () {
      if (this.seconds > 0) {
        this.seconds--
      } else if (this.tickMinutes()) {
        this.seconds = 59
      }
    },
    tickMinutes () {
      if (this.minutes > 0) {
        this.minutes--
        return true
      }
      if (this.tickHours()) {
        this.minutes = 59
        return true
      }
      return false
    },
    tickHours () {
      if (this.hours > 0) {
        this.hours--
        return true
      }
      if (this.tickDays()) {
        this.hours = 23
        return true
      }
      return false
    },
    tickDays () {
      return this.days > 0 && this.days--
    },
  },
  mounted () {
    const countdownInterval = setInterval(() => {
      if (this.seconds >= 0) {
        this.tickSeconds()
      } else {
        clearInterval(countdownInterval)
      }
    }, 1000)

    const startDate = document.querySelector('.js-start-date') || document.querySelector('.addeventatc .start')
    if (startDate) {
      const parsedDate = this.localTargetDate.toISOString().replace('T', ' ').replace(/:\d{2}\.\d{3}Z/, '')
      if (parsedDate) {
        startDate.innerHTML = parsedDate
      }
    }
  }
})
